import * as _ from "underscore";

export const TOPICS = ['accidente', 'arte', 'ciencia', 'comercio', 'cultura', 'deporte', 'derecho', 'educación', 'economía', 'empresa', 'guerra', 'industria', 'innovación', 'legal', 'lingüística', 'medio ambiente', 'militar', 'naturaleza', 'paz', 'política', 'psicología', 'religión', 'salud', 'tecnología', 'términos científicos', 'términos burocráticos', 'términos técnicos', 'trabajo', 'sociología']

export const SENTIMENTS = ['positivo', 'neutral', 'negativo']

export function addValuesIn(dictt: {}, key: string, values: string[]) {
    if (dictt[key] === undefined) {
        dictt[key] = {};
    }
    for (const val of values) {
        if (dictt[key][val] === undefined) {
            dictt[key][val] = 0;
        }
        dictt[key][val]++;
    }
}

/**
 * Returns true if `val` is one of the items in `coll`.
 *
 * Examples:
 *  - str_in('ball', ['has', 'sea', 'ball']) -> true
 *  - str_in('good', ['has', 'sea', 'ball']) -> false
 */
export function str_in(val: string, coll: string[]) {
    for (const item of coll) {
        if (item === val)
            return true;
    }
    return false;
}

/**
 * Returns true if any of the `substrings` is contained in `val`.
 *
 * Examples:
 *  - str_contains('Peter has a ball', ['has', 'sea']) -> true
 *  - str_contains('Peter has a ball', ['got', 'sea']) -> false
 */
export function str_contains(val: string, substrings: string[]) {
    for (const substr of substrings) {
        if (val.indexOf(substr) >= 0)
            return true;
    }
    return false;
}

/**
 * Replace all the occurrences of the items in `oldValues` by the `newValue`.
 * @returns The text with the replacements applied.
 */
export function replaceAll(text: string, oldValues: string[], newValue: string): string {
    let res = text;
    for (const val of oldValues) {
        while (res.indexOf(val) >= 0)
            res = res.replace(val, newValue);
    }
    return res;
}

/**
 * Filter the values that can be added to the final list.
 *
 * Exclude values of length 1, those that are articles and the ones that contains verbs.
 * @param listValues Incoming list of values.
 * @returns Filtered list of values.
 */
export function filterValues(listValues: string[], entitiesPos: {}) {
    // Remove duplicates, new-lines, symbols and one-characters' values
    const cleanedValues = []
    for (let item of listValues) {
        item = item.trim()
        item = replaceAll(item, ['\n', '“', '»', '|'], ' ').trim();
        if (item.length === 1) continue;
        if (str_contains(item, ['�', '?', '¿', '!', '¡'])) continue;
        if (!_.contains(cleanedValues, item))
            cleanedValues.push(item)
    }
    const result = [];
    // Filter the values
    const idxPOS = 2;
    for (const val of cleanedValues) {
        const posValues = entitiesPos[val]
        if (posValues === undefined) continue
        if (val.length <= 1) continue;
        // the value has a verb -> continue
        if (_.any(posValues, x => str_in(x[idxPOS], ['VERB', 'ADP', 'PUNCT']))
            || _.any(posValues, x => x[idxPOS + 1].indexOf('VERB') >= 0)) continue;
        // the value is an article -> continue
        if (posValues.length === 1
            && str_in(posValues[0][idxPOS], ['DET', 'PRON', 'ADV', 'AUX'])) continue;

        if (_.any(posValues, x => str_in(x[idxPOS], ['NOUN', 'PROPN'])))
            result.push(val);
    }
    return result;
}

export function rgba2rgb(color, alpha) {
    const baseColor = [255, 255, 255]
    return [
        (1 - alpha) * baseColor[0] + alpha * color[0],
        (1 - alpha) * baseColor[1] + alpha * color[1],
        (1 - alpha) * baseColor[2] + alpha * color[2]
    ];
}

export function getColor(cantNeg: number, cantNeu: number, cantPos: number) {
    const red = [242, 61, 66]
    const green = [79, 166, 34]
    const yellow = [255, 233, 0]
    const colors = [red, yellow, green]

    const cantList = [cantNeg, cantNeu, cantPos]
    let idxMainColor = 0
    let maxVal = 0
    for (let i = 0; i < cantList.length; i++) {
        const cantX = cantList[i];
        if (maxVal < cantX) {
            maxVal = cantX
            idxMainColor = i
        }
    }
    const mainColor = colors[idxMainColor]
    const intensity = cantList[idxMainColor] / (cantNeg + cantNeu + cantPos)
    return [mainColor, intensity]
}
